import { render, staticRenderFns } from "./Address.yaml?vue&type=template&id=245adafa&component"
import script from "./Address.yaml?vue&type=script&lang=ts&component"
export * from "./Address.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports